<template>
  <svg
    id="svg4"
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    :viewBox="viewBox"
    :class="svgClass"
    :style="svgStyle"
    version="1.1"
  >
    <path
      v-if="type == 'outline'"
      id="path2"
      d="M14.2,5.48l2.23,4.46a3,3,0,0,0,2.25,1.62l5,.73-3.58,3.4a3,3,0,0,0-.89,2.67l.86,4.94L15.64,21a2.91,2.91,0,0,0-1.42-.36,3,3,0,0,0-1.39.34L8.37,23.31l.81-4.95a3,3,0,0,0-.86-2.64L4.74,12.17l4.93-.73a2.94,2.94,0,0,0,2.2-1.29A.94.94,0,0,0,12,9.93L14.2,5.48m0-2.91a1.08,1.08,0,0,0-.95.56l-3,6a1,1,0,0,1-.82.46l-6.58,1a1.08,1.08,0,0,0-.59,1.9L7,17.07a1.09,1.09,0,0,1,.32,1L6.24,24.61a1.1,1.1,0,0,0,.11.69,1.08,1.08,0,0,0,1,.58,1.2,1.2,0,0,0,.51-.13l5.9-3.11a1.08,1.08,0,0,1,.5-.12,1.13,1.13,0,0,1,.51.12l5.9,3.11a1.14,1.14,0,0,0,.51.13l.18,0a1.09,1.09,0,0,0,.89-1.25L21.07,18a1.06,1.06,0,0,1,.32-1l4.76-4.51a1.09,1.09,0,0,0-.59-1.91L19,9.68a1.09,1.09,0,0,1-.82-.59l-3-6a1.07,1.07,0,0,0-.44-.43,1.06,1.06,0,0,0-.52-.13Z"
      :style="{ fill: fill }"
    />
    <path
      v-else-if="type == 'solid'"
      id="path2"
      d="M13.72,22.64l-5.9,3.11a1.09,1.09,0,0,1-1.47-.45,1.1,1.1,0,0,1-.11-.69L7.3,18a1.09,1.09,0,0,0-.32-1L2.3,12.42a1.08,1.08,0,0,1,.59-1.9l6.58-1a1,1,0,0,0,.82-.46l3-6a1.09,1.09,0,0,1,1.47-.43,1.07,1.07,0,0,1,.44.43l3,6a1.09,1.09,0,0,0,.82.59l6.61,1a1.09,1.09,0,0,1,.59,1.91l-4.76,4.51a1.06,1.06,0,0,0-.32,1l1.14,6.57a1.09,1.09,0,0,1-.89,1.25,1.1,1.1,0,0,1-.69-.11l-5.9-3.11A1.06,1.06,0,0,0,13.72,22.64Z"
      :style="{ fill: fill }"
    />
  </svg>
</template>
<script>
export default {
  props: {
    type: { type: String, default: "solid" },
    viewBox: { type: String, default: "0 0 28.44 28.44" },
    fill: { type: String, default: "#FFFFFF" },
    svgClass: { type: String, default: "svg-icon" },
    svgStyle: { type: Object },
  },
};
</script>
